import { request } from "@/service/request.js";

// 散客票详情
export function getIndividualOrderSingle(options) {
  return request.call(this, {
      url: "openapi/web/individual/order/single",
      method: 'POST',
      data: options
  });
};


